import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosError } from 'axios'

import { APP } from 'src/Configs/App'
import { NameSpace } from 'src/Redux/types'
import { api } from 'src/Services/api'

interface AcceptTermsNewBody {
  termsPosition: number
  termsCount: number
}

interface AcceptTermsNewResponse {
  areTermsAccepted: boolean
  termsPosition: number
}
export const acceptTermsNew = createAsyncThunk<
  AcceptTermsNewResponse,
  AcceptTermsNewBody
>(
  `${NameSpace.User}/acceptTermsNew`,
  async ({ termsPosition, termsCount }, { rejectWithValue }) => {
    try {
      const { data } = await api.patch<AcceptTermsNewResponse>(
        `${APP.TIKTOK_SERVER}/curator/users/me/terms`,
        {
          termsPosition,
          termsCount,
        },
      )
      return data
    } catch (error) {
      const { response } = error as AxiosError<{ message: string }>
      return rejectWithValue({
        message: response?.data.message,
        code: response?.status,
      })
    }
  },
)

interface GetSpotifyAvatarResponse {
  new_avatar_image: string
}

export const getSpotifyAvatar = createAsyncThunk<GetSpotifyAvatarResponse>(
  `${NameSpace.User}/getSpotifyAvatar`,
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await api.get<GetSpotifyAvatarResponse>(
        `${APP.SERVER}/user/profile-avatar`,
      )
      return data
    } catch (error) {
      const { response } = error as AxiosError<{ message: string }>
      return rejectWithValue({
        message: response?.data.message,
        code: response?.status,
      })
    }
  },
)
